<template>
  <section class="section pb-0" v-if="current_enterprise">
    <div class="title is-4 is-pulled-right">
      {{ $t("current enterprise") }}
      <span class="has-text-primary">{{ current_enterprise.name }}</span>
      <span class="has-text-warning" v-if="current_period">
        ({{ current_period.name }})</span
      >
    </div>
  </section>
  <section class="section container">
    <div class="grid is-col-min-7">
      <div class="cell" @click="manage_entities">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/9166/9166850.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("enterprises") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="manage_accounts">
        <div class="card">
          <div class="card-image">
            <figure
              class="image is-64x64 m-auto py-4"
              v-bind:style="[
                current_enterprise ? { opacity: 1 } : { opacity: 0.3 },
              ]"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/2942/2942263.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p
                  class="title is-5 has-text-centered"
                  v-bind:class="{
                    'has-text-grey-dark': !current_enterprise,
                  }"
                >
                  {{ $t("accounts") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="manage_policies">
        <div class="card">
          <div class="card-image">
            <figure
              class="image is-64x64 m-auto py-4"
              v-bind:style="[
                current_enterprise ? { opacity: 1 } : { opacity: 0.3 },
              ]"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/4599/4599122.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p
                  class="title is-5 has-text-centered"
                  v-bind:class="{
                    'has-text-grey-dark': !current_enterprise,
                  }"
                >
                  {{ $t("policies") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <entity-manager-modal
      ref="entity_manager_modal"
      @set_as_current="set_enterprise"
      @set_period="set_period"
    />
  </section>
</template>

<script>
import { warning_message, get } from "@/utils";
import EntityManagerModal from "./entity_manager_modal/Index.vue";

export default {
  name: "AccountingIndex",
  components: { EntityManagerModal },
  data() {
    return {
      is_loading: false,
      current_enterprise: undefined,
      current_period: undefined,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    manage_entities() {
      this.$refs.entity_manager_modal.show_modal();
    },
    set_enterprise(enterprise) {
      this.current_enterprise = enterprise;
      /**
       * TODO
       * load selected enterprise information
       */
    },
    set_period(data) {
      let v = this;
      v.current_enterprise = data.enterprise;
      v.current_period = data.period;
      /**
       * TODO
       * load selected period information
       */
    },
    manage_accounts() {
      let v = this;
      if (v.current_period) {
        v.$router.push({
          path: `/accounting/accounts/${v.current_period.uuid}`,
        });
      } else {
        warning_message(v.$t("select period first"));
      }
    },
    manage_policies() {
      let v = this;
      if (v.current_period) {
        v.$router.push({
          path: `/accounting/policies/${v.current_period.uuid}`,
        });
      } else {
        warning_message(v.$t("select period first"));
      }
    },
  },
  mounted() {
    let v = this;
    if (v.$route.params.period_uuid) {
      get("/accounting/period", {
        uuid: v.$route.params.period_uuid,
      })
        .then((period) => {
          // console.log(period);
          v.current_enterprise = period.accounting_enterprise;
          v.current_period = period;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  },
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
